import { useState, useMemo } from 'react';

export default function useTableSearchPagination({
  data,
  filterFn,
  initialPageSize = 10,
  extraDeps = []
}) {
  const [searchText, setSearchText] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(initialPageSize);

  const filteredData = useMemo(() => {
    if (!Array.isArray(data)) return [];
    return data.filter(item => filterFn(item, searchText));
  }, [data, searchText, filterFn, ...extraDeps]);

  const onSearchChange = value => {
    setSearchText(value);
    setPage(1); // reset página SIEMPRE
  };

  const pagination = {
    current: page,
    pageSize,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '50', '100'],
    onChange: p => setPage(p),
    onShowSizeChange: (_, size) => {
      setPageSize(size);
      setPage(1);
    }
  };

  return {
    searchText,
    onSearchChange,
    filteredData,
    pagination
  };
}
